import React, { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Chart from './chart';
import Style from './style';
import Widget from '../../widget';
import { getProgress } from '../helpers';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';

const placeholder = '0';

export default function InformationAvailabillity({
  data = {},
  subjectName = '',
  isSingleSource,
  loading,
}) {
  const { t } = useTranslation();
  const [active, setActive] = useState(null);
  const isSolo = isSingleSource;

  return (
    <Widget loading={loading} title={t('Information Availability')} className="custom-width">
      <Style className="default-content">
        <div className={formatClassname(['custom-chart-cont'])}>
          <Chart
            dataA={data.completionRate ? data.completionRate * 0.01 : 0}
            dataB={!isSolo ? data.subjectSelfAssessment * 0.01 : null}
            active={active}
            doOpacity={false} 
            setActive={setActive}
          >
            {isSolo ? (
              <div className="chart-children">
                <div className="value">
                  <div className="legend" />
                  <label className="percentage">{getProgress(Number(data.completionRate)) || placeholder}%</label>
                </div>
                <div className="total-progress">
                  <label>{t('Completion Rate')}</label>
                </div>
              </div>
            ) : null}
          </Chart>
        </div>
        {!isSolo && (
          <div className="legend">
            <div
              className="default-data"
              style={{ opacity: active === 'SELF' ? 0.4 : 1 }}
            >
              <div className="default-data default-content">
                <div className="value-cont">
                  <div className="main">
                    <div className="square" style={{ background: 'var(--color-primary-70)' }} />
                  </div>
                  <label className="value">
                    {getProgress(Number(data.completionRate || 0)) || placeholder}%
                  </label>
                </div>
                <label className="label">{t('Combined')}</label>
              </div>
            </div>
            <div
              className="default-data"
              style={{ opacity: active === 'COMBINED' ? 0.4 : 1 }}
            >
              <div className="default-data default-content">
                <div className="value-cont">
                  <div className="main">
                    <div className="square" style={{ background: '#ABD6FF' }} />
                  </div>
                  <label className="value">
                    {getProgress(Number(data.subjectSelfAssessment || 0)) || placeholder}%
                  </label>
                </div>
                <label className="label">
                  <Trans i18nKey="reportedBy">
                    {{ subjectName }}
                  </Trans>
                </label>
              </div>
            </div>
          </div>
        )}
      </Style>
    </Widget>
  )
}
